import { FC, useEffect, useRef } from 'react';

const MAX_HEIGHT = 16 * 10;

const adjustHeight = (element: HTMLTextAreaElement | null) => {
  if (!element) return;
  element.style.height = 'inherit';
  element.style.height = `${Math.min(element.scrollHeight, MAX_HEIGHT)}px`;
};

type TextareaOwnProps = {
  autoResizing?: boolean;
};
export type TextareaProps = TextareaOwnProps &
  Omit<React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>, 'onInput'> & {
    onInput?: React.FormEventHandler<HTMLTextAreaElement>;
  };

export const Textarea: FC<TextareaProps> = ({ autoResizing = true, onInput, ...props }) => {
  const textbox = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    if (!autoResizing) return;
    adjustHeight(textbox.current);
  }, [autoResizing, props.value]);

  const handleInput: React.FormEventHandler<HTMLTextAreaElement> = (event) => {
    if (!autoResizing) {
      onInput?.(event);
      return;
    }
    adjustHeight(textbox.current);
    onInput?.(event);
  };

  return <textarea {...props} ref={textbox} onInput={handleInput}></textarea>;
};
